import { concat } from '@ember/helper';
import style from 'ember-style-modifier/modifiers/style';
import clampTooltip from '../../modifiers/clamp-tooltip.ts';
import type { TOC } from '@ember/component/template-only';

interface ChartTooltipSignature {
  Args: {
    /** Viewport x of the anchor, in px. */
    x: number;
    /** Viewport y of the anchor, in px. */
    y: number;
    /** CSS transform that offsets the tooltip from its anchor, when set inline. */
    transform?: string;
  };
  Blocks: { default: [] };
  Element: HTMLDivElement;
}

const ChartTooltip: TOC<ChartTooltipSignature> = <template>
  <div
    class="tio-chart-tooltip"
    {{style left=(concat @x "px") top=(concat @y "px") transform=@transform}}
    {{clampTooltip (concat @x ":" @y ":" @transform)}}
    ...attributes
  >
    {{yield}}
  </div>
</template>;

export default ChartTooltip;
